import store from "@/store";

export default [
  {
    meta: {
      title: "Secure"
    },
    path: "/secure",
    name: "Secure",
    component: () => import("@/views/secure/Secure1.vue")
  },
  {
    meta: {
      title: "Secure2"
    },
    path: "/secure2",
    name: "Secure2",
    component: () => import("@/views/secure/Secure2.vue")
  },

  {
    meta: {
      title: "Qna"
    },
    path: "/qna",
    name: "Qna",
    component: () => import("@/views/default/Qna.vue")
  },
  {
    meta: {
      title: "Faq"
    },
    path: "/faq",
    name: "Faq",
    component: () => import("@/views/default/Faq.vue")
  },

  {
    meta: {
      title: "Keepsake"
    },
    path: "/keepsake",
    name: "Keepsake",
    component: () => import("@/views/default/Keepsake.vue")
  },

  {
    meta: {
      title: "Format"
    },
    path: "/format",
    name: "Format",
    component: () => import("@/views/default/Format.vue")
  },

  {
    meta: {
      title: "Notice"
    },
    path: "/notice",
    name: "Notice",
    component: () => import("@/views/default/Notice.vue")
  },
  {
    meta: {
      title: "NoticeDetail"
    },
    path: "/noticeDetail",
    name: "NoticeDetail",
    component: () => import("@/views/default/NoticeDetail.vue")
  },

  {
    meta: {
      title: "PasswordSetting"
    },

    path: "/passwordSetting",
    component: () => import("@/views/default/PasswordSetting.vue")
  },
  {
    meta: {
      title: "ObituaryTmpUser"
    },
    path: "/tmp",
    component: () => import("@/views/default/Tmp.vue")
  }
];
